import {apiGet, apiPost, apiPut} from "../../shared/api/client";

const APP_TEXTS_URL = "/api/v2/admin/content/app-texts";

export const appTextsKeys = {
    all: ["admin-content-app-texts"],
    scope: () => ["admin-content-app-texts", "scope"],
    sections: (countryId, locale) => ["admin-content-app-texts", "sections", String(countryId), locale],
    section: (countryId, locale, section) => ["admin-content-app-texts", "section", String(countryId), locale, section],
    preview: (countryId, locale, section, draftKey) => [
        "admin-content-app-texts",
        "preview",
        String(countryId),
        locale,
        section,
        draftKey,
    ],
    // Prefix of every preview key of one section, used to drop them after a save.
    sectionPreviews: (countryId, locale, section) => [
        "admin-content-app-texts",
        "preview",
        String(countryId),
        locale,
        section,
    ],
};

// The (country, language) address always travels as explicit query params, so the
// request interceptor never substitutes the header country scope.
const addressConfig = ({countryId, locale}) => ({params: {country_id: countryId, locale}});

const sectionUrl = (section) => `${APP_TEXTS_URL}/sections/${encodeURIComponent(section)}`;

// A section body carries exactly one content field: `document` for the structured
// section, `values` for phrase sections and full pages.
const contentBody = ({values, document}) => (
    document !== undefined && document !== null ? {document} : {values: values ?? {}}
);

export const loadAppTextsScope = async () =>
    apiGet(`${APP_TEXTS_URL}/scope`, {skipAdminCountryScope: true});

export const loadAppTextSections = async ({countryId, locale}) =>
    apiGet(`${APP_TEXTS_URL}/sections`, addressConfig({countryId, locale}));

export const loadAppTextSection = async ({countryId, locale, section}) =>
    apiGet(sectionUrl(section), addressConfig({countryId, locale}));

export const previewAppTextSection = async ({countryId, locale, section, values, document}) =>
    apiPost(`${sectionUrl(section)}/preview`, contentBody({values, document}), addressConfig({countryId, locale}));

export const saveAppTextSection = async ({countryId, locale, section, values, document, expectedVersion}) =>
    apiPut(
        sectionUrl(section),
        {...contentBody({values, document}), expected_version: expectedVersion ?? null},
        addressConfig({countryId, locale}),
    );
